module.exports = __webpack_public_path__ + "static/media/expiration_new.d58027cc.png";